import PropTypes from 'prop-types';
import { Button } from 'ypf-pas-general-ui-components';
import { MdInsertComment, MdOutlineComment } from 'react-icons/md';

import { useWorkReportModals } from '../../../../../context/WorkReportModalsContext';
import { assignmentTypeEnum } from '../../../../../utils/dataStatus';
import { partesTrabajoDiarioItemsWorkReport } from '../../../../../utils/globalPropTypes';
import ComponentWithTooltip from '../../../../ComponentWithTooltip/ComponentWithTooltip';

import styles from './CommentsWorkReportApproverButton.module.scss';

const CommentsWorkReportApproverButton = ({ dailyWorkReport, selectedDate }) => {
  const { activeCommentsModal } = useWorkReportModals();
  const setColor = () => {
    if (dailyWorkReport?.contieneComentarios) {
      return 'primary';
    }

    return 'dark';
  };

  return (
    <ComponentWithTooltip id="hidden-tooltip" tooltipText="Mensajes">
      <div className={`d-flex justify-content-evenly ${styles.container}`}>
        <Button
          className={styles['button-with-tooltip']}
          colorIcon={setColor()}
          icon={dailyWorkReport?.contieneComentarios ? MdInsertComment : MdOutlineComment}
          onClick={() =>
            activeCommentsModal({
              ...dailyWorkReport,
              date: selectedDate,
              monthly: dailyWorkReport.tipoAsignacion === assignmentTypeEnum.Mensualizada
            })
          }
          type="button"
          variant="light"
          widthButton="30px"
        />
      </div>
    </ComponentWithTooltip>
  );
};

export default CommentsWorkReportApproverButton;

CommentsWorkReportApproverButton.propTypes = {
  dailyWorkReport: partesTrabajoDiarioItemsWorkReport.isRequired,
  selectedDate: PropTypes.string.isRequired
};
